import { DataManager, Query, Predicate } from '@syncfusion/ej2-data';
import { datasource } from '../layout/test/data';
export const getFilterItems = (fList: any, list: any, uniqId: string): any => {
  let nodes = [];
  nodes.push(fList[uniqId]);
  let query2 = new Query().where(uniqId, 'equal', fList['pid'], false);
  let fList1 = new DataManager(list).executeLocal(query2);
  if (fList1.length !== 0) {
    let pNode: any = getFilterItems(fList1[0], list, uniqId);
    for (let i = 0; i < pNode.length; i++) {
      if (nodes.indexOf(pNode[i]) === -1 && pNode[i] != null)
        nodes.push(pNode[i]);
    }
    return nodes;
  }
  return nodes;
};

export const searchNodes = (
  value: any,
  source_data: Array<any>,
  changeDataSource: (data: any) => void,
  searchFor: string,
  uniqId: string
) => {
  let _text = value;
  let predicats = [],
    _array = [],
    _filter = [];
  if (_text === '') {
    changeDataSource(source_data);
  } else {
    let TradePersons: any[] = [];
    let Trades: any[] = [];
    // Effect both team and trade textbox components
    source_data.map((each) => {
      if (each.pid) {
        TradePersons.push(each);
      } else {
        Trades.push(each);
      }
    });
    let predicate = new Predicate(searchFor, 'contains', _text, true);
    let filteredList: any = new DataManager(Trades).executeLocal(
      new Query().where(predicate)
    );
    for (let j = 0; j < filteredList.length; j++) {
      _filter.push(filteredList[j][uniqId]);
      let filters = getFilterItems(filteredList[j], source_data, uniqId);
      for (let i = 0; i < filters.length; i++) {
        if (_array.indexOf(filters[i]) === -1 && filters[i] != null) {
          _array.push(filters[i]);
          predicats.push(new Predicate(uniqId, 'equal', filters[i], false));
        }
      }
    }
    if (predicats.length === 0) {
      changeDataSource([]);
    } else {
      let query = new Query().where(Predicate.or(predicats));
      let newList: any[] = new DataManager(source_data).executeLocal(query);
      TradePersons.map((each) => {
        newList.push(each);
      });
      changeDataSource(newList);
    }
  }
};
